import { withProjectCardStyle } from 'root/src/client/web/list/listItemComponents/style'
import { useDareCard } from 'root/src/client/web/list/listItemComponents/dare/hooks/useDareCard'
import { useBlackCardContext } from 'root/src/client/web/base/Card/BlackCard/hooks/useBlackCardContext'
import TooltipWrapper from 'root/src/client/web/base/TooltipWraper'
import { platformsLabelMap } from 'root/src/shared/constants/providers'
import Link from 'root/src/client/web/base/Link'
import { CONNECTED_CHANNELS_ROUTE_ID } from 'root/src/shared/descriptions/routes/routeIds'
import LoadingButtonNew from 'root/src/client/web/base/LoadingButtonNew'
import { LazyLoadImage } from 'react-lazy-load-image-component'
import classNames from 'classnames'
import { addHttpsProtocol } from 'root/src/shared/util/protocolUtil'
import {
	ProjectCardLabel,
	statusColorsMap,
	statusLabels,
} from 'root/src/client/web/list/listItemComponents/project/ProjectCardLabel'
import { ProjectTimeLeft } from 'root/src/client/web/list/listItemComponents/project/ProjectCardHeader'
import outOfStock from 'root/src/client/public/out-of-stock.png'
import { useClipboard } from 'root/src/client/web/hooks/useClipboard'
import ClipboardIcon from 'root/src/client/public/icons/ic-clipboard.svg'
import {
	maxDaresReachedMessage,
	noMaxDaresMessage,
	notAbleToParticipateMessage,
} from 'root/src/shared/constants/dropEvent'

const getButtonText = (projectAssignees, subscribed, comingSoon, canAccessCreateBrandProject) => {
	if (canAccessCreateBrandProject) {
		return 'CREATE DARE'
	}

	if (comingSoon) {
		return subscribed ? 'NOT AVAILABLE NOW' : 'JOIN DROP'
	}

	return projectAssignees ? 'PLEDGE' : 'ACCEPT DARE'
}

const OutOfStockBadge = withProjectCardStyle(({ classes }) => (
	<div className={classes.badgeContainer}>
		<img alt="Out of stock" src={outOfStock.src} />
	</div>
))

const ShareLinkOverlay = withProjectCardStyle(({ classes, shareUrl }) => {
	const { writeText } = useClipboard()
	return (
		<button
			onClick={() => writeText(shareUrl)}
			type="button"
			className={classes.shareDareButton}
		>
			<img src={ClipboardIcon.src} alt="Clipboard" />
			<p className={classes.shareDareLink}>
				Share Link
			</p>
		</button>
	)
})

// TODO we should probably merge display tooltip and tooltip message logic
function DareButtonTooltip({ classes }) {
	const {
		extraData: {
			user: {
				isAbleToParticipate,
				isDarePlatformAvailable,
				isMaxDaresReached,
				maxDares,
			},
		},
		dare: {
			platform: darePlatform,
		},
	} = useDareCard()

	if (!isAbleToParticipate) {
		return (
			<p className={classes.buttonTooltip}>
				{notAbleToParticipateMessage}
			</p>
		)
	}

	if (!isDarePlatformAvailable) {
		return (
			<p className={classes.buttonTooltip}>
				This Dare is only for {platformsLabelMap[darePlatform]}<br />
				you can connect it <Link routeId={CONNECTED_CHANNELS_ROUTE_ID}>here</Link>
			</p>
		)
	}

	if (!maxDares) {
		return (
			<p className={classes.buttonTooltip}>
				{noMaxDaresMessage}
			</p>
		)
	}

	if (isMaxDaresReached) {
		return (
			<p className={classes.buttonTooltip}>
				{maxDaresReachedMessage}
			</p>
		)
	}

	return null
}

export const DareCardHeader = withProjectCardStyle(({ classes }) => {
	const {
		isLoading,
		dare: {
			games,
			title,
			landingShortUrl,
		},
		actions: {
			onAccept,
		},
		extraData: {
			labels,
			user: {
				isDareButtonEnabled,
			},
			dareCardContext: {
				projectDeliveries,
				projectAssignees, scrollPosition,
				projectAccepted,
				emailSubscription, comingSoon,
				canAccessCreateBrandProject, dumb,
			},
			isInteracted,
			isOutOfStock,
			timeLeft,
		},
	} = useDareCard()
	const { isHovered } = useBlackCardContext()

	return (
		<div className={classes.projectCardHeader}>
			{!dumb && isHovered && !isInteracted && (
				<div className={classes.ctaButtonOverlay}>
					<TooltipWrapper
						tooltipText={(
							!isDareButtonEnabled && <DareButtonTooltip classes={classes} />
						)}
					>{!isOutOfStock
							&& (
								<LoadingButtonNew
									disabled={!isDareButtonEnabled}
									loading={isLoading}
									onClick={onAccept}
									type="secondary"
								>
									{getButtonText(
										projectAssignees,
										emailSubscription,
										comingSoon,
										canAccessCreateBrandProject,
									)}
								</LoadingButtonNew>
							)
						}
					</TooltipWrapper>
				</div>
			)}
			<LazyLoadImage
				src={projectDeliveries ? projectDeliveries.thumbnail : games[0].image}
				alt={title}
				scrollPosition={scrollPosition}
				className={classNames({
					[classes.thumbnail]: true,
					[classes.image]: true,
					[classes.smOpacity]: true,
					[classes.tiktokThumbnail]: projectDeliveries?.platform === 'tiktok',
					[classes.scaledUp]: isHovered,
					[classes.scaledDown]: !isHovered,
				})}
			/>
			{isHovered && landingShortUrl && (
				<ShareLinkOverlay shareUrl={addHttpsProtocol(landingShortUrl)} />
			)}
			<div className={classes.badgesWrapper}>
				<div className={classes.badgesContainer}>
					<div className={classes.marksContainer}>
						{labels.map(label => (
							<ProjectCardLabel
								key={label}
								status={statusLabels[label]}
								color={statusColorsMap[label]}
							/>
						))}
					</div>
					{isOutOfStock && <OutOfStockBadge />}
					{projectAccepted && <ProjectTimeLeft timeLeft={timeLeft} />}
				</div>
			</div>
		</div>
	)
})
